import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PuenteApi from '../../../pageauth/PuenteApi';

export const SidebarRemoteWork = () => {
    const navigate = useNavigate();
    const { CerrarSession } = PuenteApi()
    const [configOpen, setConfigOpen] = useState(false);
    const [combustiblesOpen, setCombustiblesOpen] = useState(false);
    const [playaMiniOpen, setPlayaMiniOpen] = useState(false);
    const [proveedoresOpen, setProveedoresOpen] = useState(false);
    const [activeId, setActiveId] = useState('');

    useEffect(() => {
        const url = window.location.pathname;
        const segments = url.split('/').filter(Boolean);
        const targetId = segments[2] || segments[1] || segments[0] || '';
        setActiveId(targetId);
        setConfigOpen(segments.includes('configuracion'));
        setCombustiblesOpen(segments.includes('combustibles'));
        setPlayaMiniOpen(segments.includes('playamini'));
        setProveedoresOpen(segments.includes('proveedores'));
    }, []);

    const handleConfigToggle = (event) => {
        event.preventDefault();
        setConfigOpen((prev) => !prev);
    };

    const handleCombustiblesToggle = (event) => {
        event.preventDefault();
        setCombustiblesOpen((prev) => !prev);
    };

    const handlePlayaMiniToggle = (event) => {
        event.preventDefault();
        setPlayaMiniOpen((prev) => !prev);
    };

    const handleProveedoresToggle = (event) => {
        event.preventDefault();
        setProveedoresOpen((prev) => !prev);
    };

    const handleSalir = async () => {
        await CerrarSession();
        navigate('/');
    };
    return (
        <aside className="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 fixed-start ms-3" id="sidenav-main">
            <div className="sidenav-header">
                <i className="fas fa-times p-3 cursor-pointer text-secondary opacity-5 position-absolute end-0 top-0 d-none d-xl-none" aria-hidden="true" id="iconSidenav"></i>
                <a className="navbar-brand m-0" href="/remotework" rel="noopener noreferrer">
                    <img src="/img/logo.webp" className="navbar-brand-img" alt="main_logo" />
                    <span className="ms-1 font-weight-bold">Panel Administación</span>
                </a>
            </div>
            <hr className="horizontal dark mt-0" />
            <div className="navbar-collapse w-auto" id="sidenav-collapse-main" >
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className={`nav-link ${activeId === 'remotework' ? 'active' : ''}`} href="/remotework" id="Remotework">
                            <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="fa fa-home" style={{ color: "black" }}></i>
                            </div>
                            <span className="nav-link-text ms-1">Dashboard</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className={`nav-link ${activeId === 'clientes' ? 'active' : ''}`} href="/remotework/clientes" id="clientes">
                            <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="fa fa-user" style={{ color: "black" }}></i>
                            </div>
                            <span className="nav-link-text ms-1">Clientes</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className={`nav-link ${activeId === 'usuarios' ? 'active' : ''}`} href="/remotework/usuarios" id="usuarios">
                            <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="fa fa-users" style={{ color: "black" }}></i>
                            </div>
                            <span className="nav-link-text ms-1">Usuarios</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className={`nav-link ${activeId === 'empleados' ? 'active' : ''}`} href="/remotework/empleados" id="empleados">
                            <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="fa fa-id-card" style={{ color: "black" }}></i>
                            </div>
                            <span className="nav-link-text ms-1">Empleados</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link d-flex align-items-center justify-content-between ${activeId === 'proveedores' || activeId === 'administrar' || activeId === 'contable' ? 'active' : ''}`}
                            id="proveedores"
                            onClick={handleProveedoresToggle}
                            aria-expanded={proveedoresOpen}
                            aria-controls="submenu-proveedores"
                        >
                            <div className="d-flex align-items-center">
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i className="fa fa-truck" aria-hidden="true" style={{ color: "black" }}></i>
                                </div>
                                <span className="nav-link-text ms-1">Proveedores</span>
                            </div>
                            <i className={`fa ${proveedoresOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" style={{ color: "black" }}></i>
                        </button>
                        {proveedoresOpen && (
                            <>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-proveedores">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'administrar' ? 'active' : ''}`} href="/remotework/proveedores/administrar" id="administrar">
                                            <span className="nav-link-text ms-1">Administrar</span>
                                        </a>
                                    </li>
                                </ul>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-proveedores">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'contable' ? 'active' : ''}`} href="/remotework/proveedores/contable" id="contable">
                                            <span className="nav-link-text ms-1">Contable</span>
                                        </a>
                                    </li>
                                </ul>
                            </>
                        )}
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link d-flex align-items-center justify-content-between ${activeId === 'combustibles' ? 'active' : ''}`}
                            id="combustibles"
                            onClick={handleCombustiblesToggle}
                            aria-expanded={combustiblesOpen}
                            aria-controls="submenu-combustibles"
                        >
                            <div className="d-flex align-items-center">
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="fa fa-gas-pump" aria-hidden="true" style={{ color: "black" }}></i>
                                </div>
                                <span className="nav-link-text ms-1">Combustibles</span>
                            </div>
                            <i className={`fa ${combustiblesOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" style={{ color: "black" }}></i>
                        </button>
                        {combustiblesOpen && (
                            <>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-combustibles">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'combustibles' ? 'active' : ''}`} href="/remotework/combustibles/combustibles" id="combustibles">
                                            <span className="nav-link-text ms-1">Gestionar Combustibles</span>
                                        </a>
                                    </li>
                                </ul>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-combustibles">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'tanques' ? 'active' : ''}`} href="/remotework/combustibles/tanques" id="tanques">
                                            <span className="nav-link-text ms-1">Gestionar Tanques</span>
                                        </a>
                                    </li>
                                </ul>
                            </>
                        )}
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link d-flex align-items-center justify-content-between ${activeId === 'playamini' ? 'active' : ''}`}
                            id="playamini"
                            onClick={handlePlayaMiniToggle}
                            aria-expanded={playaMiniOpen}
                            aria-controls="submenu-playamini"
                        >
                            <div className="d-flex align-items-center">
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="fa fa-store" aria-hidden="true" style={{ color: "black" }}></i>
                                </div>
                                <span className="nav-link-text ms-1">Playa/Mini</span>
                            </div>
                            <i className={`fa ${playaMiniOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" style={{ color: "black" }}></i>
                        </button>
                        {playaMiniOpen && (
                            <>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-playamini">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'playa' ? 'active' : ''}`} href="/remotework/playamini/playa" id="playa">
                                            <span className="nav-link-text ms-1">Playa</span>
                                        </a>
                                    </li>
                                </ul>
                                <ul className="nav flex-column ms-4 submenu" id="submenu-playamini">
                                    <li className="nav-item">
                                        <a className={`nav-link ${activeId === 'minimercado' ? 'active' : ''}`} href="/remotework/playamini/minimercado" id="minimercado">
                                            <span className="nav-link-text ms-1">Minimercado</span>
                                        </a>
                                    </li>
                                </ul>
                            </>
                        )}
                    </li>
                    <li className="nav-item">
                        <button
                            type="button"
                            className={`nav-link d-flex align-items-center justify-content-between ${activeId === 'configuracion' ? 'active' : ''}`}
                            id="configuracion"
                            onClick={handleConfigToggle}
                            aria-expanded={configOpen}
                            aria-controls="submenu-configuracion"
                        >
                            <div className="d-flex align-items-center">
                                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                    <i class="fa fa-cog" aria-hidden="true" style={{ color: "black" }}></i>
                                </div>
                                <span className="nav-link-text ms-1">Configuración</span>
                            </div>
                            <i className={`fa ${configOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden="true" style={{ color: "black" }}></i>
                        </button>
                        {configOpen && (
                            <ul className="nav flex-column ms-4 submenu" id="submenu-configuracion">
                                <li className="nav-item">
                                    <a className={`nav-link ${activeId === 'modulos' ? 'active' : ''}`} href="/remotework/configuracion/modulos" id="modulos">
                                        <span className="nav-link-text ms-1">Modulos</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a className={`nav-link ${activeId === 'razonessociales' ? 'active' : ''}`} href="/remotework/configuracion/razonessociales" id="razonessociales">
                                        <span className="nav-link-text ms-1">Razones Sociales</span>
                                    </a>
                                </li>
                            </ul>
                        )}
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" onClick={() => handleSalir()} id="Salir">
                            <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                                <i class="fa fa-arrow-left" aria-hidden="true" style={{ color: "black" }}></i>
                            </div>
                            <span className="nav-link-text ms-1">Cerrar Sesion</span>
                        </a>
                    </li>
                    {/* Agregar más enlaces según sea necesario */}
                </ul>
            </div>
        </aside>
    );
};

